import React from 'react';
import { withFormsy } from 'formsy-react';
import { useTheme } from '@mui/material/styles';

import Icon from '../Icon';
import BaseTextField, { type FieldProps } from './components/BaseTextField';

type BooleanDescFieldProps = {
	/** The icon name */
	icon: string;
	/** The icon color */
	color: string;
} & Omit<FieldProps<boolean>, 'startAdornment' | 'endAdornment'>;

function BooleanDescField(props: BooleanDescFieldProps) {
	const theme = useTheme();

	function handleChange(event) {
		if (props.beforeChange) props.beforeChange(event.target.value);
		props.sendChange(event.target.name, event.target.value);
		if (props.afterChange) props.afterChange(event.target.value);
	}

	function handleKeyDown(event) {
		if (event.key === 'Enter') {
			event.preventDefault();
			handleChange(event);
		}
	}

	return (
		<BaseTextField
			className={props.className}
			name={props.name}
			label={props.label}
			defaultValue={props.value || ''}
			autoComplete="off"
			isEdit={props.isEdit}
			startAdornment={
				<Icon icon={props.icon} color={!props.value ? theme.palette.action.disabled : props.color} />
			}
			required={props.required}
			errorMessage={props.errorMessage}
			isFormSubmitted={props.isFormSubmitted}
			isPristine={props.isPristine}
			isValid={props.isValid}
			logProps={props.logProps}
			onBlur={handleChange}
			onKeyDown={handleKeyDown}
		/>
	);
}

export default React.memo(withFormsy(BooleanDescField));
